// extracted by mini-css-extract-plugin
module.exports = {"Modal":"ErrorHandler_Modal__KlagZ","ActiveModal":"ErrorHandler_ActiveModal__2v-Vu","Backdrop":"ErrorHandler_Backdrop__31Gqk"};